import React, { useEffect, useState } from 'react';
import { ReactComponent as Logo } from '../../assets/icons/LogoHeader.svg';
import cn from 'classnames';
import styles from './Header.module.css';
import HeaderButton from '../UI/HeaderButton/HeaderButton';
import HeaderIconButton from '../UI/HeaderIconButton/HeaderIconButton';
import {
  MAIN_PAGE,
  BUSINESS_PAGE,
  PARKING_PAGE,
  PROJECTS_PAGE,
  COMPARE_PAGE,
  MORTGAGE_PAGE,
  FAVORITE_PAGE,
  NEWS_PAGE,
} from '../../router/paths';
import PhoneCallModal from '../PhoneCallModal/PhoneCallModal';

type HeaderProps = {
  theme: 'light' | 'dark';
};

const Header: React.FC<HeaderProps> = ({ theme }) => {
  const [isHeaderHovered, setIsHeaderHovered] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 1440);
  const [isModalOpened, setIsModalOpened] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth > 1440);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleModal = () => {
    setIsModalOpened((prev) => !prev);
  };

  return (
    <>
      <header
        className={cn(styles.wrapper, {
          [styles.light]: theme === 'light',
          [styles.dark]: theme === 'dark',
        })}
        onMouseEnter={() => setIsHeaderHovered(true)}
        onMouseLeave={() => setIsHeaderHovered(false)}
      >
        <div className={styles.logo}>
          <a href={MAIN_PAGE} className={styles.logo_link}>
            <Logo
              width='62'
              height='25'
              className={cn(styles.logo_icon, {
                [styles.light_logo]: theme === 'light',
                [styles.dark_logo]: theme === 'dark',
              })}
            />
          </a>
        </div>

        <nav className={styles.nav}>
          <HeaderButton to={PROJECTS_PAGE} theme={theme} isHeaderHovered={isHeaderHovered}>
            Проекты
          </HeaderButton>

          <HeaderButton to={BUSINESS_PAGE} theme={theme} isHeaderHovered={isHeaderHovered}>
            Коммерция
          </HeaderButton>

          <HeaderButton to={PARKING_PAGE} theme={theme} isHeaderHovered={isHeaderHovered}>
            Машино-места
          </HeaderButton>

          <HeaderButton to={MORTGAGE_PAGE} theme={theme} isHeaderHovered={isHeaderHovered}>
            Рассрочка
          </HeaderButton>

          <HeaderButton to={NEWS_PAGE} theme={theme} isHeaderHovered={isHeaderHovered}>
            Новости
          </HeaderButton>
        </nav>

        <div className={styles.icon_buttons}>
          {isLargeScreen ? (
            <HeaderButton theme={theme} isHeaderHovered={isHeaderHovered} onClick={handleModal}>
              +7 938 151-22-22
            </HeaderButton>
          ) : (
            <HeaderIconButton
              iconName='icon1'
              theme={theme}
              isHeaderHovered={isHeaderHovered}
              onClick={handleModal}
            />
          )}
          <HeaderIconButton
            iconName='favorite_header'
            to={FAVORITE_PAGE}
            theme={theme}
            isHeaderHovered={isHeaderHovered}
          />
          <HeaderIconButton
            iconName='compare_header'
            to={COMPARE_PAGE}
            theme={theme}
            isHeaderHovered={isHeaderHovered}
          />
        </div>
      </header>
      <PhoneCallModal onClose={handleModal} isActive={isModalOpened} />
    </>
  );
};

export default Header;
